import { render, staticRenderFns } from "./particles-stars.vue?vue&type=template&id=1de64823&scoped=true&"
import script from "./particles-stars.vue?vue&type=script&lang=js&"
export * from "./particles-stars.vue?vue&type=script&lang=js&"
import style0 from "./particles-stars.vue?vue&type=style&index=0&id=1de64823&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de64823",
  null
  
)

export default component.exports